var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.className,attrs:{"to":_vm.homeRoute},domProps:{"textContent":_vm._s(_vm.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }